<div class="p-4">
  <div class="d-flex justify-content-between mb-3">
    <div>
      <h4 class="modal-title" id="efx-modal-label">Sesión a punto de expirar</h4>
    </div>
    <div>
      <button class="efx-button-link text-black" (click)="handleSession(0)"><span class="material-symbols-outlined"> close </span></button>
    </div>
  </div>

  <p>Por tu seguridad, tu sesión se cerrará automáticamente por inactividad.</p>

  <p>Te quedan <strong>{{minutes}} minuto(s) y {{secondsText}} segundo(s)</strong> para mantener la sesión activa.</p>

  <div class="d-flex justify-content-center align-items-center">
    <div class="me-4">
      <button class="efx-button-primary" cdkFocusInitial (click)="handleSession(1)">Continuar sesión</button>
    </div>
    <div>
      <button class="efx-button-danger" (click)="handleSession(0)">Cerrar sesión</button>
    </div>
  </div>
</div>
